import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, DidYouKnow } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran16() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "16");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 16" title="Regrets">
        <YouTubeEmbed videoId="T_cS93lN84c" title="Regrets — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/16-regrets.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="B♭ major — a loop that starts on vi">
        {/* Jason's annotation: vi, V, IV  |  chart: Gm | F | Eb | Eb F  |  no Bb chord in the loop */}
        <RomanNumeralAnalysis
          label="Main progression"
          caption="Gm → F → E♭ → E♭ F. Jason writes vi, V and IV above the chords — the I chord (B♭) is not in the loop."
          chords={[
            { chord: "Gm", rn: "vi", function: "Submediant",   pitches: ["G3","Bb3","D4","G4"] },
            { bar: true },
            { chord: "F",  rn: "V",  function: "Dominant",     pitches: ["F3","A3","C4","F4"] },
            { bar: true },
            { chord: "Eb", rn: "IV", function: "Pre-dominant", pitches: ["Eb3","G3","Bb3","Eb4"] },
            { bar: true },
            { chord: "Eb", rn: "IV", function: "Pre-dominant", pitches: ["Eb3","G3","Bb3","Eb4"] },
            { chord: "F",  rn: "V",  function: "Dominant",     pitches: ["F3","A3","C4","F4"] },
          ]}
        />
        <KeyIdea title="vi as home">
          B♭, the I chord, never appears in this loop. Every time round, F leads back to Gm (vi) instead — so Gm starts to feel like the resting point, even though Jason labels the key B♭ major.
        </KeyIdea>
      </Section>
      <Section eyebrow="Takeaway" title="Leaving out the I chord">
        <DidYouKnow title="Avoiding the I chord">
          When a loop never touches the tonic chord, the vi chord can take over as the place the music rests. Gm stops sounding like "away from B♭" and starts sounding like home.
        </DidYouKnow>
      </Section>
    </LessonShell>
  );
}
